import { render, staticRenderFns } from "./post-details.vue?vue&type=template&id=9481f99a&"
import script from "./post-details.vue?vue&type=script&lang=js&"
export * from "./post-details.vue?vue&type=script&lang=js&"
import style0 from "./post-details.vue?vue&type=style&index=0&id=9481f99a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports